import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy, computed } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { getOrderedContentPages, ResetEvents, ResetNews } from '../../store';
import { ContentPage, Event, News, PageData } from '../../models';
import * as fromRoot from '../../../store';
import { map, take, takeUntil } from 'rxjs/operators';
import * as fromContent from '../../store';
import { ActivatedRoute } from '@angular/router';
import { ResetBlogs } from '../../../blogs/store';
import { CardComponent } from '../../../core/components/card/card.component';
import { PaginationComponent } from '../../../core/components/pagination/pagination.component';
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { StripHtmlPipe, TruncatePipe, UrlRewritePipe } from '@teamfoster/sdk/text-utility';

@Component({
  selector: 'app-content-overview',
  templateUrl: './content-overview.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CardComponent, PaginationComponent, AsyncPipe, TitleCasePipe, FromDictionaryPipe, UrlRewritePipe, StripHtmlPipe, TruncatePipe],
})
export class ContentOverviewComponent implements OnInit, OnDestroy {
  private store = inject(Store);
  private route = inject(ActivatedRoute);

  hasPagination = false;

  // Pagination
  page$ = this.store.selectSignal(fromContent.getSelectedOverviewPage);
  items$ = this.store.selectSignal(fromContent.getSelectedOverviewItemsOrdered);

  pages$ = computed(() => {
    const page = this.page$();
    return Array((page?.pageCount || 0) + 1)
      .fill(0)
      .map((x, i) => i);
  });

  contentType$ = this.store
    .select(fromRoot.getRouterState)
    .pipe(map(a => a.state.params?.['contentType'] || a.state.data?.['contentType']))

  private _unsubscribe = new Subject<void>();

  ngOnInit() {
    this.route.queryParams.pipe(takeUntil(this._unsubscribe)).subscribe(params => {
      this.hasPagination = !!params?.['page'];
    });
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }

  asAny(item: any): any {
    return item as any;
  }
}
